const defaultStockLevels = [
  // Order matters! The `findStock()` method will walk through this array and stop at its first match
  {
    threshold: 10,
    labelId: "inStock"
  },
  {
    threshold: 5,
    labelId: "lowStock"
  },
  {
    threshold: 1,
    labelId: "veryLowStock"
  },
  {
    threshold: 0,
    labelId: "outOfStock"
  }
];
const getStockLevels = (thresholdConfig = []) => defaultStockLevels.map((level) => ({
  ...level,
  ...thresholdConfig.find((threshold) => threshold.labelId === level.labelId)
}));
const stockResolver = (channelAvailability, allowBackOrder, stockCount, thresholdConfig) => {
  const positiveStockCount = Math.max(stockCount || 0, 0);
  if (channelAvailability === "IN_STORE_ONLY" || !positiveStockCount && !allowBackOrder) {
    return {
      threshold: 0,
      labelId: "outOfStock"
    };
  }
  const stockLevel = getStockLevels(thresholdConfig).find(
    (stockLevel2) => positiveStockCount >= stockLevel2.threshold
  );
  if (stockLevel?.labelId === "outOfStock" && allowBackOrder) {
    return {
      threshold: 0,
      labelId: "backOrder"
    };
  }
  return stockLevel;
};
export {
  defaultStockLevels,
  getStockLevels,
  stockResolver
};
//# sourceMappingURL=helpers.js.map
